import { createApp } from 'vue';
import App from '@/vue/App.vue';
import router from '@/router.js';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faHome, faTasks, faMapMarkerAlt, faList, faUser, faSignOutAlt, faListCheck } from '@fortawesome/free-solid-svg-icons';
/* add icons to the library */
library.add(faHome, faTasks, faMapMarkerAlt, faList, faUser, faSignOutAlt, faListCheck);


createApp(App)
    .use(router)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app');
